var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgScale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.9 20H2.1C.9 20 0 19.1 0 17.9V2.1C0 .9.9 0 2.1 0h15.8c1.2 0 2.1.9 2.1 2.1V18c0 1.1-.9 2-2.1 2",
  fill: "#8278c8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8 5.8c0 2-1.7 3.7-3.8 3.7S6.2 7.9 6.2 5.8 7.9 2.2 10 2.2s3.8 1.6 3.8 3.6",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6.9h-5.9v1.6c1.3.6 2 1.8 2 3.2 0 2-1.7 3.7-3.7 3.7-2.1 0-3.7-1.7-3.7-3.7 0-1.4.7-2.6 2-3.2V.9h-6C1.6.9 1 1.6 1 2.3v15.5c0 .7.6 1.3 1.4 1.3h15.3c.7 0 1.4-.6 1.4-1.3V2.3C19 1.6 18.4.9 17.6.9",
  fill: "#9792d6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 19.1h7.7c.7 0 1.4-.6 1.4-1.3V2.3c0-.7-.6-1.3-1.4-1.3h-6v1.6c1.3.6 2 1.8 2 3.2 0 2-1.7 3.7-3.7 3.7",
  fill: "#8c8bc9"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.8 6.4V9h.4V6.4c.2-.1.4-.3.4-.6s-.3-.6-.6-.6-.6.3-.6.6.2.5.4.6m1.9-2.1s0-.1 0 0l.7-.6v-.1h-.2l-.6.6c0-.1 0 0 .1.1-.1-.1-.1-.1 0 0-.1-.1 0 0 0 0m-4 3.9s.1-.1 0 0l.7-.6v-.1h-.2l-.6.5s0 .1.1.2c-.1-.1-.1-.1 0 0-.1-.1 0 0 0 0m4.5-.1h.2V8l-.6-.6h-.2v.1l.6.6zM7.6 3.5v.1l.6.6h.2v-.1l-.6-.6c-.1-.1-.1-.1-.2 0m-.8 2.3c0 .1 0 .1.1.1h.8c.1 0 .1 0 .1-.1s0-.1-.1-.1h-.8c-.1 0-.1 0-.1.1m5.5.1h.8c.1 0 .1 0 .1-.1s0-.1-.1-.1h-.8c-.1 0-.1 0-.1.1 0 0 0 .1.1.1z",
  fill: "#8e82f2"
})));
export default SvgScale;